import React from "react";
import { useParams } from "react-router-dom";
import RGA_report from "./ReportItems/RGA_report";
import InitialContactReport from "./ReportItems/InitialContactReport";
import ActiveClientsReport from "./ReportItems/ActiveClientsReport";
import B2BReferralsReport from "./ReportItems/B2BReferralsReport";
import WebIntakeReport from "./ReportItems/WebIntakeReport";
import ResourcePartnerReport from "./ReportItems/ResourcePartnerReport";
import GeneralClientReport from "./ReportItems/GeneralClientReport";
import EcosystemReport from "./ReportItems/EcosystemReport";
import LargeScreenNotice from "../../common/LargeScreenNotice";

const ReportContent = ({ id }: { id?: string }) => {
  if (id === "rga") {
    return <RGA_report />;
  } else if (id === "initial_contact") {
    return <InitialContactReport />;
  } else if (id === "active_clients") {
    return <ActiveClientsReport />;
  } else if (id === "b2b_referrals") {
    return <B2BReferralsReport />;
  } else if (id === "webintake") {
    return <WebIntakeReport />;
  } else if (id === "resource_referrals") {
    return <ResourcePartnerReport />;
  } else if (id === "ecosystem") {
    return <EcosystemReport />;
  } else if (
    // Demographics + operations are merged into the general client report;
    // the old paths still resolve so existing links keep working.
    id === "general_client" ||
    id === "client_demographics" ||
    id === "engagement_operations"
  ) {
    return <GeneralClientReport />;
  } else {
    return <>No matching Report found</>;
  }
};

const Report = () => {
  const { id } = useParams();

  return (
    <>
      <LargeScreenNotice pageKey="report" />
      <ReportContent id={id} />
    </>
  );
};

export default Report;
